import {
  CatalogProductSchema_,
  CatalogVariantSchema_,
} from "@redotech/redo-model/catalog/catalog-product-types";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const MarketplaceListingSchema_ = CatalogProductSchema_.extend({
  variants: z.array(
    CatalogVariantSchema_.extend({ available: z.number().min(0) }),
  ),
});
export const MarketplaceListingSchema: z.ZodType<MarketplaceListing> =
  MarketplaceListingSchema_;
export interface MarketplaceListing
  extends z.infer<typeof MarketplaceListingSchema_> {}

export const getMarketplaceListings = {
  name: "getMarketplaceListings" as const,
  input: z.object({ productId: zExt.objectId() }),
  output: z.object({ listings: z.array(MarketplaceListingSchema) }),
};
